import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Refresh = function Refresh(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.071 8.001a1.002 1.002 0 00-1.131.85c-.417 2.935-2.971 5.15-5.94 5.15a6.001 6.001 0 01-3.838-1.399l1.679-1.678A.542.542 0 005.458 10H.541a.54.54 0 00-.541.541v4.917c0 .481.583.724.924.382l1.815-1.815A8.008 8.008 0 008 16c3.959 0 7.364-2.953 7.921-6.868a1.001 1.001 0 00-.85-1.13zM16 .542V5.46a.54.54 0 01-.541.541h-4.917a.541.541 0 01-.383-.924l1.679-1.678A6.003 6.003 0 008 2C5.03 2 2.476 4.214 2.059 7.15a1.001 1.001 0 01-1.98-.282C.635 2.953 4.041 0 8 0c1.954 0 3.818.717 5.26 1.975L15.076.16A.542.542 0 0116 .542z",
    fill: "currentColor"
  }));
};
export default Refresh;